// Store billing (OP#2948). A plan bought in the iOS app is billed by Apple: the
// server refuses Stripe checkout and credit top-ups for it (409 MANAGED_BY_APPLE),
// so the web must not offer them either — only point at the App Store.

export const MANAGED_BY_APPLE = "MANAGED_BY_APPLE";

// The server refuses to connect another account when the plan is full (OP#2997,
// OP#3009): 403 with data.code on /accounts/add, error_code in the OAuth redirect.
export const ACCOUNT_LIMIT_CODES = ["total_limit", "platform_limit"];
export const ACCOUNT_LIMIT_REDIRECT_CODE = "ACCOUNT_LIMIT";

/**
 * Whether the App Store bills this user's plan.
 * Accepts the meta-info payload ({ billing, user }) or a bare user row.
 * @param {Object} data - metaData or user
 * @returns {boolean} True when the plan is billed by the App Store
 */
export function isAppleBilled(data) {
  const source =
    data?.billing?.source ?? data?.user?.billing_source ?? data?.billing_source;
  return source === "apple";
}
